export const NavBar = {
  tag: 'nav', flow: 'x', align: 'center space-between', padding: 'A B', background: 'transparent', position: 'sticky', top: '0', zIndex: '100', width: '100%',
  LogoLink: {
    extends: 'Link', href: '/', textDecoration: 'none', flow: 'x', align: 'center center', gap: 'W',
    LogoIcon: { extends: 'Icon', icon: 'fourStar', width: 'A', height: 'A', color: 'inkText' },
    LogoText: { text: 'MCAI', fontSize: 'A', fontWeight: '700', color: 'inkText' }
  },
  NavLinks: { flow: 'x', gap: 'B', align: 'center center', position: 'absolute', left: '50%', attr: { style: 'transform: translateX(-50%)' }, '@mobileL': { display: 'none' },
    FeaturesLink: { extends: 'Link', text: '{{ features | polyglot }}', href: '/business#features', color: 'inkSubtle', fontSize: 'Z', textDecoration: 'none', fontWeight: '500' },
    PricingLink: { extends: 'Link', text: '{{ pricing | polyglot }}', href: '/business#pricing', color: 'inkSubtle', fontSize: 'Z', textDecoration: 'none', fontWeight: '500' },
    ClinicsLink: { extends: 'Link', text: '{{ clinicsNav | polyglot }}', href: '/clinics', color: 'inkSubtle', fontSize: 'Z', textDecoration: 'none', fontWeight: '500' },
    AiLink: { extends: 'Link', text: '{{ aiAssistant | polyglot }}', href: '/business#ai', color: 'inkSubtle', fontSize: 'Z', textDecoration: 'none', fontWeight: '500' },
    ForBusinessLink: { extends: 'Link', text: '{{ forBusiness | polyglot }}', href: '/business', color: 'inkSubtle', fontSize: 'Z', textDecoration: 'none', fontWeight: '500' }
  },
  NavRight: { flow: 'x', gap: 'Z', align: 'center center',
    LangMenu: {
      position: 'relative',
      flow: 'x',
      align: 'center center',

      LangBtn: {
        tag: 'button',
        flow: 'x',
        align: 'center center',
        gap: 'W',
        padding: 'X Z',
        round: 'Z',
        cursor: 'pointer',
        background: 'transparent',
        border: 'none',
        ':hover': { background: 'inkSurface' },
        onClick: (e, el, s) => {
          e.stopPropagation()
          s.root.update({ activeLangMenu: !s.root.activeLangMenu })
        },
        LangFlag: {
          fontSize: 'A',
          text: (el, s) => {
            var flags = { en: '\uD83C\uDDEC\uD83C\uDDE7', ka: '\uD83C\uDDEC\uD83C\uDDEA', ru: '\uD83C\uDDF7\uD83C\uDDFA', uk: '\uD83C\uDDFA\uD83C\uDDE6', tr: '\uD83C\uDDF9\uD83C\uDDF7', zh: '\uD83C\uDDE8\uD83C\uDDF3', hi: '\uD83C\uDDEE\uD83C\uDDF3', msa: '\uD83C\uDDF8\uD83C\uDDE6' }
            return flags[s.root.lang] || flags.en
          }
        },
        LangCode: {
          fontSize: 'Z',
          fontWeight: '600',
          color: 'inkSubtle',
          '@mobileL': { display: 'none' },
          text: (el, s) => {
            var codes = { en: 'EN', ka: 'GE', ru: 'RU', uk: 'UA', tr: 'TR', zh: 'ZH', hi: 'HI', msa: 'AR' }
            return codes[s.root.lang] || 'EN'
          }
        }
      },

      LangDropdown: {
        flow: 'y',
        position: 'absolute',
        top: '100%',
        right: '0',
        marginTop: 'Y',
        background: 'inkMid',
        round: 'Z',
        border: '1px solid inkBorder',
        boxShadow: '0 A B inkBorder',
        padding: 'Y 0',
        minWidth: 'F',
        zIndex: '300',
        show: (el, s) => s.root.activeLangMenu,
        LangEn: { extends: 'LangOption', state: { langCode: 'en', flag: '\uD83C\uDDEC\uD83C\uDDE7', name: 'English' } },
        LangKa: { extends: 'LangOption', state: { langCode: 'ka', flag: '\uD83C\uDDEC\uD83C\uDDEA', name: '\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8' } },
        LangRu: { extends: 'LangOption', state: { langCode: 'ru', flag: '\uD83C\uDDF7\uD83C\uDDFA', name: '\u0420\u0443\u0441\u0441\u043A\u0438\u0439' } },
        LangUk: { extends: 'LangOption', state: { langCode: 'uk', flag: '\uD83C\uDDFA\uD83C\uDDE6', name: '\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430' } },
        LangTr: { extends: 'LangOption', state: { langCode: 'tr', flag: '\uD83C\uDDF9\uD83C\uDDF7', name: 'T\u00FCrk\u00E7e' } },
        LangZh: { extends: 'LangOption', state: { langCode: 'zh', flag: '\uD83C\uDDE8\uD83C\uDDF3', name: '\u4E2D\u6587' } },
        LangHi: { extends: 'LangOption', state: { langCode: 'hi', flag: '\uD83C\uDDEE\uD83C\uDDF3', name: '\u0939\u093F\u0928\u094D\u0926\u0940' } },
        LangMsa: { extends: 'LangOption', state: { langCode: 'msa', flag: '\uD83C\uDDF8\uD83C\uDDE6', name: '\u0627\u0644\u0639\u0631\u0628\u064A\u0629' } }
      }
    },

    CtaLink: { extends: 'Link', text: '{{ getStarted | polyglot }}', href: '/booking', background: 'inkText', color: 'white', fontWeight: '600', padding: 'Y A', round: 'Z', fontSize: 'Z', textDecoration: 'none' }
  }
}
